import { useContext } from 'react';
import { FeaturesContext, FeaturesContextType } from '../context/FeaturesContext';

/**
 * Hook to access feature flags from the FeaturesContext.
 * Must be used within a FeaturesProvider.
 *
 * @returns Feature flags and loading state
 * @throws Error if used outside FeaturesProvider
 */
export const useFeatures = (): FeaturesContextType => {
  const context = useContext(FeaturesContext);

  if (!context) {
    throw new Error('useFeatures must be used within a FeaturesProvider');
  }

  return context;
};
